import styled from 'styled-components';
import { keyframes } from 'styled-components';

export const ModalContentFullOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(31, 31, 31, 0.9);
  z-index: 1000;
`;

const FadeInAnimation = keyframes`
  0% {opacity:0;}
  100% {opacity:1;}
`;

export const ModalContent = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  overflow: scroll;
  margin: 20px;
  height: 91.4vh;
  animation: ${FadeInAnimation} 300ms linear;
`;

// TODO: remove these zindex 1000 :)
export const ModalCloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 4px;
  cursor: pointer;
  z-index: 1000;
  border: none;
  background-color: transparent;
`;
